module.exports = __webpack_public_path__ + "img/h.38d9f6b9.png";